import _ from "lodash";
import { CollectionAdapter } from "../../../main/adapters/CollectionAdapter/CollectionAdapter";
import { getDate } from "../../../utils/date/date";

const PointsAccountingAnalyticsCollection = new Mongo.Collection(
    "PointsAccountingAnalyticsCollection",
    {
        connection: null
    }
);

export class PointsAccountingAnalytics extends CollectionAdapter {
    constructor() {
        super(PointsAccountingAnalyticsCollection);
    }

    creteByReport(reports = [], accountingId) {
        const total = reports.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const report = reports[i];

            [
                {
                    v: report.feedbacksSum,
                    s: "REPORT_SUM_FEEDBACK_BY_MONTH"
                },
                {
                    v: report.sharedSum,
                    s: "REPORT_SUM_SHARED_BY_MONTH"
                },
                {
                    v: report.vizBySum,
                    s: "REPORT_SUM_VIZ_BY_MONTH"
                }
            ].forEach((valuePoint) => {
                if (valuePoint.v) {
                    this.create({
                        t: getDate(report.date),
                        c: report.companyId,
                        v: valuePoint.v,
                        s: valuePoint.s,
                        so: report.sources,
                        a: accountingId
                    });
                }
            });
        }

        return true;
    }

    creteByCompaniesKpis(
        pointsKpis,
        companiesWithPreferencesKpis = [],
        accountingId
    ) {
        const total = pointsKpis.length;

        if (!total) return false;

        const sourceOptions = {
            a: "accounting",
            f: "financial",
            p: "personnel",
            t: "tax"
        };

        for (let i = 0; i < total; i++) {
            const point = pointsKpis[i];

            if (!point) return false;

            if (companiesWithPreferencesKpis.length) {
                const company =
                    companiesWithPreferencesKpis.find(
                        (c) => c._id == point.c
                    ) || {};

                const kpiSourcesPreferece = {
                    IMPOSTOS: _.get(company, "preferences.imposto.mainSource")
                        ? _.get(company, "preferences.imposto.mainSource")
                        : "accounting",
                    RECEITAS: _.get(company, "preferences.receita.mainSource")
                        ? _.get(company, "preferences.receita.mainSource")
                        : "accounting",
                    "NUMERO DE FUNCIONARIOS": "personnel"
                };

                const pointSource = _.get(sourceOptions, `${point.so[0]}`);

                if (kpiSourcesPreferece[point.s] == pointSource) {
                    this.create({
                        t: getDate(point.t),
                        c: point.c,
                        v: point.s == "IMPOSTOS" ? Math.abs(point.v) : point.v,
                        s: point.s,
                        so: pointSource,
                        a: accountingId
                    });
                }
            }
        }

        return true;
    }

    createMany(data = [], fields = {}) {
        this._before();

        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const document = data[i];
            if (!document) continue;
            else if (document.t) document.t = new Date(document.t);

            this.create({ ...document, ...fields });
        }

        return true;
    }
}
